import type { DocSection } from '../types'

export const historySection: DocSection = {
  id: 'historique',
  title: 'Historique & enregistrements',
  icon: 'list',
  accent: '#6366F1',
  summary: "Retrouver vos appels passés, réécouter l'audio, mettre en favori, comprendre la rétention.",
  minRole: 'agent',
  articles: [
    {
      id: 'cdr',
      title: "L'historique des appels",
      summary: 'La liste de vos appels avec numéros, durée, résultat.',
      icon: 'list',
      blocks: [
        { type: 'p', text: "La page **Historique** liste les appels avec : sens (entrant/sortant), numéros, durée, statut (répondu, sans réponse, occupé…), **disposition** posée, et l'**agent**." },
        { type: 'p', text: "Un **agent ne voit que ses propres appels** ; les responsables voient tout leur périmètre." },
        { type: 'h', text: 'Filtrer et rechercher' },
        { type: 'kv', items: [
          { k: 'Période', v: "Une date de début et de fin pour cibler une journée, une semaine…" },
          { k: 'Sens', v: "Appels entrants, sortants ou internes." },
          { k: 'Statut', v: "Répondu, sans réponse, occupé, échec, messagerie." },
          { k: 'Campagne / Disposition', v: "Pour ne voir que les appels d'une campagne ou d'un résultat donné." },
          { k: 'Recherche', v: "Tapez tout ou partie d'un numéro." },
          { k: 'Avec enregistrement / Favoris', v: "Restreindre aux appels enregistrés ou marqués favoris." },
        ] },
        { type: 'callout', variant: 'tip', text: "Les **statistiques** affichées suivent les mêmes filtres que la liste : les chiffres correspondent toujours à ce que vous voyez." },
        { type: 'callout', variant: 'info', title: 'D\'où vient l\'historique', text: "Chaque appel crée une fiche dans l'historique à la fin de la communication, rattachée automatiquement à la bonne campagne et au bon agent." },
      ],
    },
    {
      id: 'ecoute',
      title: 'Réécouter et télécharger un enregistrement',
      summary: 'Le bouton lecture, le téléchargement et ses droits.',
      icon: 'headphones',
      blocks: [
        { type: 'p', text: "Quand un appel a été **enregistré et décroché**, un bouton **lecture** ▶ apparaît dans l'historique. Cliquez pour réécouter dans le navigateur." },
        { type: 'kv', items: [
          { k: 'Écouter', v: "Owner/Admin/Superviseur : tous les enregistrements. Agent : **uniquement les siens**." },
          { k: 'Télécharger', v: "Réservé à Owner/Admin et à l'agent **propriétaire**, et seulement si le droit a été **accordé** par un superviseur. Interdit par défaut." },
        ] },
        { type: 'callout', variant: 'info', title: 'Pas d\'audio sur un appel non décroché', text: "Un appel sans réponse n'a pas d'enregistrement exploitable : il n'a donc pas de bouton lecture." },
      ],
    },
    {
      id: 'favoris',
      title: 'Favoris & rétention des enregistrements',
      summary: 'Comment garder un enregistrement plus longtemps.',
      icon: 'star',
      blocks: [
        { type: 'p', text: "Les enregistrements ne sont **pas conservés indéfiniment** : l'audio des appels anciens est purgé automatiquement (les **métadonnées** de l'appel, elles, restent toujours dans l'historique)." },
        { type: 'h', text: 'Comment conserver un enregistrement' },
        { type: 'list', items: [
          "Le mettre en **Favori** (icône étoile) — il échappe à la purge. La page **Favoris** les regroupe.",
          "Le qualifier en **Vente** ou **RDV** : l'audio est **automatiquement protégé**.",
        ] },
        { type: 'callout', variant: 'info', title: 'Bon à savoir', text: "Après la purge du serveur local, un enregistrement protégé reste accessible : il est conservé dans le stockage durable et rejoué à la demande. Seul l'audio non protégé et ancien est supprimé." },
      ],
    },
  ],
}
